import SparkMD5 from 'spark-md5';

export const getFileChecksum = async (file: File): Promise<string> =>
  new Promise((resolve, _reject) => {
    const fileReader = new FileReader();

    fileReader.onloadend = () => {
      resolve(
        Buffer.from(SparkMD5.ArrayBuffer.hash(fileReader.result as any), 'hex').toString('base64'),
      );
    };
    fileReader.readAsArrayBuffer(file);
  });
